import React, { useEffect, useState } from 'react'
import { Link, NavLink, } from 'react-router-dom'
import {
    checkFile, dataTableLanguaje, globalSettings, globalSettingsPassword, responseGet, sendMessageCloseCurrentWindowAsync,
    dateTimeFormatGlobalSet, styles, languageObjGet, isUndNullEmp, LoadingSection, validatePhoneNumber
} from '../../helpers/settings'

import HtmlParser from 'react-html-parser';

import $ from 'jquery';
import Menu from '../main/Menu'
import useAuth from '../../controllers/users/useAuth';

import axios from 'axios';
import Swal from 'sweetalert2';
import { fileUploadAsync } from '../../controllers/dataBase/actions';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { buildingModelGet } from '../../models/buildings/building';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { userModelGet } from '../../models/users/user';
import { buildingContractModelGet } from '../../models/buildings/buildingContract';

const currentMethod = 'Profile';

const { app, collections: dbColle, colors, html, icons, images, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { html: reactHtml, sweetAlert2, } = react;
const { properties: dbProps, } = dbColle;

export default function Profile({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    //const history = useHistory();

    const [user, setUser] = useState(userModelGet({}));
    const [tabsDisable, setTabsDisable] = useState(false);
    const [userPhotoAccept, setUserPhotoAccept] = useState('');
    const [userLastLogginDate, setUserLastLogginDate] = useState('');
    const [userLastLogginTime, setUserLastLogginTime] = useState('');
    const [apartments, setApartments] = useState([apartmentModelGet({})]);
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    const [showLoading, setShowLoading] = useState({ user: true, profile: true, });
    const fileTypes = app?.fileTypes?.images;
    //#endregion variables

    //#region contracts
    const userDataTabId = 'userData';
    const dtContractsId = 'dtContracts';
    const userSecurityTabId = 'userSecurity';
    const userContractsTabId = 'userContracts';
    //#region old code
    // const [contract, setContract] = useState({
    //     contractId: '',
    //     userId: '',
    // });
    //#endregion old code
    //#region old code
    //const [errorContractId, setErrorContractId] = useState('');
    //#endregion old code
    //#endregion contracts

    //#region update user (Variables)
    const [errorFirstName, setErrorFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState('');
    const [errorPhoneNumber, setErrorPhoneNumber] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    //#endregion update user (Variables)

    //#region change password (Variables)
    const setFormDataDefaultChangePassword = () => {
        return {
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
        };
    };
    const [formDataChangePassword, setFormDataChangePassword] = useState(setFormDataDefaultChangePassword());
    const [errorCurrentPassword, setErrroCurrentPassword] = useState('');
    const [errorNewPassword, setErrroNewPassword] = useState('');
    const [errorConfirmNewPassword, setErrorConfirmNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    //#endregion change password (Variables)

    //#region others
    const controls = {
        buttons: {
            profileSave: {
                id: 'btnProfileSave',
                className: 'btn btn-outline-primary float-right mx-1',
            },
            passwordSave: {
                id: 'btnPasswordSave',
                className: 'btn btn-outline-primary float-right mx-1',
            },
            contractAdd: {
                id: 'btnContractAdd',
                className: 'btn btn-outline-success btn-sm float-right mx-1',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            contracts: {
                buttons: {
                    // add: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btndtBanksIdAdd',
                    // },
                },
                icons: {
                    // add: {
                    //     id: 'icondtBanksIdAdd',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtContractsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtContractsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // add: {
                    //     id: 'spdtCoinsIdAdd',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            profileSave: {
                id: 'icoProfileSave',
                className: icons?.save,
            },
            passwordSave: {
                id: 'icoPasswordSave',
                className: icons?.save,
            },
            contractAdd: {
                id: 'icoContactAdd',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            profileUserPhoto: {
                id: 'inputProfileUserPhoto',
                className: 'custom-file-input',
            },
            profileFirstName: {
                id: 'inputProfileFirstName',
                className: 'form-control',
            },
            profileLastName: {
                id: 'inputProfileLastName',
                className: 'form-control',
            },
            profilePhoneNumber: {
                id: 'inputProfilePhoneNumber',
                className: 'form-control',
            },
            profileEmail: {
                id: 'inputProfileEmail',
                className: 'form-control',
            },
            passwordCurrent: {
                id: 'inputPasswordCurrent',
                className: 'form-control',
            },
            passwordNew: {
                id: 'inputPasswordNew',
                className: 'form-control',
            },
            passwordConfirm: {
                id: 'inputPasswordConfirm',
                className: 'form-control',
            },
            contractCode: {
                id: 'inputContractCode',
                className: 'form-control',
            },
        },
        pictures: {
            user: {
                id: 'picUserPhoto',
                className: 'profile-user-img img-fluid img-circle',
            }
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            profileSave: {
                id: 'spProfileSave',
                className: '',
            },
            passwordSave: {
                id: 'spPasswordSave',
                className: '',
            },
            contractAdd: {
                id: 'spContractAdd',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (user)
    const userProfileEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'userProfileEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let tokenUserLocal = {};
            let userFirebaseLocal = {};
            //#endregion variables

            //#region check values
            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion check values

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region user (update / VzLa)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                user: {
                    ...user,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    phoneNumber: user.phoneNumber,
                    photoName: user.photoName,
                    photoURL: user.photoURL,
                },
                partialUpdate: true,
                firebaseUserUpdate: true,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion user (update / VzLa)

            //#region user (update / firebase / local)
            tokenUserLocal = response?.result?.token || '';
            userFirebaseLocal = response?.result?.userFirebase || {};
            userFirebaseLocal.tokenVzLaCondominios = tokenUserLocal;

            response = auth?.updateLocalUser({
                userNew: userFirebaseLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion user (update / firebase / local)

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            //#region data get
            response = await dataGetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ user: false, profile: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion data get

            sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.userUpdatedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ user: false, profile: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const userImageProfileChangeGet = ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'userImageProfileChangeGet';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const userImageProfileChangePostAsync = async ({
        e = '',
        subMethod = '',
    }) => {
        const currentMethod = 'userImageProfileChangePostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let userTokenLocal = {};
            let userPhotoUrlLocal = '';
            let userFirebaseLocal = {};
            let userPhotoNameLocal = auth?.user?.uid;
            const targetValueLocal = e?.target?.value;
            const targetFilesLocal = e?.target?.files?.[0];
            //#endregion variables

            if (!isUndNullEmp({ data: targetValueLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ user: true, profile: false, });

                //#region check file
                response = checkFile({
                    fileType: targetFilesLocal?.type,
                    fileSize: targetFilesLocal?.size,
                    fileAllowedTypes: fileTypes,
                    fileMaxSize: app?.profile?.images?.maxSize,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
                    setShowLoading({ user: false, profile: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion check file

                //#region file delete (photo)
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    buildingId: buildings?.[0]?.id || '',
                    folder: backend?.documents?.profileImage,
                    fileName: userPhotoNameLocal,
                    method: backend?.methods?.fileDelete,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlFiles}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
                    setShowLoading({ user: false, profile: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion file delete (photo)

                //#region file upload (photo)
                response = await fileUploadAsync({
                    folder: backend?.documents?.profileImage,
                    file: targetFilesLocal,
                    fileName: userPhotoNameLocal,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
                    setShowLoading({ user: false, profile: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                userPhotoUrlLocal = response?.result || {};

                user.photoName = userPhotoNameLocal;
                user.photoURL = userPhotoUrlLocal;
                //#endregion file upload (photo)

                //#region account (update / VzLa / firebase)
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                const userVzLaLocal = {
                    ...user,
                    photoName: userPhotoNameLocal,
                    photoURL: userPhotoUrlLocal,
                };

                dataObj = {
                    user: userVzLaLocal,
                    partialUpdate: true,
                    firebaseUserUpdate: true,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
                    setShowLoading({ user: false, profile: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion account (update / VzLa / firebase)

                //#region user (update / firebase / local)
                userTokenLocal = response?.result?.token || {};
                userFirebaseLocal = response?.result?.userFirebase || {};
                userFirebaseLocal.tokenVzLaCondominios = userTokenLocal;

                response = auth?.updateLocalUser({
                    userNew: userFirebaseLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
                    setShowLoading({ user: false, profile: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion user (update / firebase / local)

                $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
                setShowLoading({ user: false, profile: false, });
                sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
        } catch (ex) {
            $(`#${controls?.inputs?.profileUserPhoto?.id}`)?.val('');
            setShowLoading({ user: false, profile: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const changePasswordFormDataValidate = ({
        subMethod = '',
    }) => {
        const currentMethod = 'changePasswordFormDataValidate';
        let response = responseGet();
        try {
            //#region methods
            if (isUndNullEmp({ data: formDataChangePassword?.currentPassword, subMethod: currentMethod, })?.result) {
                setErrroCurrentPassword(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formDataChangePassword?.currentPassword?.length < globalSettingsPassword?.minLength) {
                setErrroCurrentPassword(messages?.youMustEnterValidPassword?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formDataChangePassword?.newPassword, subMethod: currentMethod, })?.result) {
                setErrroNewPassword(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formDataChangePassword?.newPassword?.length < globalSettingsPassword?.minLength) {
                setErrroNewPassword(messages?.youMustEnterValidNewPassword?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formDataChangePassword?.confirmNewPassword, subMethod: currentMethod, })?.result) {
                setErrorConfirmNewPassword(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formDataChangePassword?.confirmNewPassword.length < globalSettingsPassword?.minLength) {
                setErrorConfirmNewPassword(messages?.youMustEnterValidNewPasswordConfirm?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formDataChangePassword?.newPassword !== formDataChangePassword?.confirmNewPassword) {
                setErrorConfirmNewPassword(messages?.newPasswordAndNewPasswordConfirmNotMatch?.[languageObj?.id]);
                setErrroNewPassword(messages?.newPasswordAndNewPasswordConfirmNotMatch?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const changePasswordErrorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'changePasswordErrorsDefaultSet';
        let response = responseGet();
        try {
            //#region methods
            setErrroNewPassword('');
            setErrroCurrentPassword('');
            setErrorConfirmNewPassword('');
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const userPasswordChangeAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'userPasswordChangeAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region data validate
            setShowPassword(false);

            response = changePasswordErrorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = changePasswordFormDataValidate({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion data validate

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region password change
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                id: auth?.user?.uid,
                email: auth?.user?.email,
                password: formDataChangePassword?.currentPassword,
                newPassword: formDataChangePassword?.newPassword,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}${backend?.urlChangePassword}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion password change

            setFormDataChangePassword(
                setFormDataDefaultChangePassword()
            );
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            //#region redirect to loggin
            response.msgText = `${messages?.thePasswordHasBeenUpdatedSuccessfully?.[languageObj?.id]}<br/>`;
            response.msgText += `${messages?.youWillNeedToLogInAgainWithTheUpdatedPassword?.[languageObj?.id]}`;

            const swalProperties = {
                icon: sweetAlert2?.icons?.success,
                title: labels?.information?.[languageObj?.id],
                html: response.msgText,
                timer: null,
                confirmButtonColor: colors?.successColorExp,
                //confirmButtonText: labels?.accept,
                showCancelButton: false,
                cancelButtonColor: colors?.secondaryColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showDenyButton: false,
                denyButtonText: labels?.detail?.[languageObj?.id],
                denyButtonColor: colors?.primaryColorExp,
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            await Swal?.fire(swalProperties);

            response = auth?.logout({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            window.location.href = backend?.urlLogin;
            //#endregion Redirec to loggin
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (user)

    //#region contracts (methods)
    //#region old code
    // const userContractAddAsync = async ({
    //     e = {},
    //     subMethod = '',
    // }) => {
    //     const currentMethod = 'userContractAddAsync';
    //     let response = responseGet();
    //     try {
    //         //#region initialize
    //         if (!isUndefined(e.preventDefault) && !isNull(e.preventDefault)) {
    //             e.preventDefault();
    //         }
    //         //#endregion initialize

    //         //#region variables
    //         let dtRow = [];
    //         let buildingLocal = buildingModelGet({});
    //         let contractLocal = buildingContractModelGet({});
    //         //#endregion variables

    //         //#region errors default set
    //         response = userContractErrorsDefaultSet({
    //             subMethod: currentMethod,
    //         });

    //         if (!response?.isSuccess || response?.isWarning) {
    //             return;
    //         }
    //         //#endregion errors default set

    //         //#region data validate
    //         response = await userContractDataValidate({
    //             subMethod: currentMethod,
    //         });

    //         if (!response?.isSuccess || response?.isWarning) {
    //             return;
    //         }
    //         //#endregion data validate

    //         //#region check data in dataTable
    //         const dtDataLocal = $(`#${dtContractsId}`)?.DataTable()?.columns(0)?.data();
    //         if (!isUndNullEmp({ data: dtDataLocal, subMethod: currentMethod, })?.result &&
    //             !isUndNullEmp({ data: dtDataLocal?.[0], subMethod: currentMethod, })?.result &&
    //             dtDataLocal?.[0]?.length > 0) {
    //             const dtDataIdExistsLocal = dtDataLocal?.[0]?.includes(contract?.contractId);
    //             if (dtDataIdExistsLocal) {
    //                 response.msgText = `${messages?.thisContractIsAlreadyAdded?.[languageObj?.id]}<br/>`;
    //                 response.msgText += `${labels?.contract?.[languageObj?.id]}: <b>${contract?.contractId}</b><br/>`;
    //                 response.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
    //                 await sendMessageCloseCurrentWindowAsync({
    //                     msgType: response?.msgType,
    //                     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //                     closeWindow: false,
    //                     urlGoTo: response?.urlGoTo,
    //                     auth: auth,
    //                     isLogout: false,
    //                     languageId: languageObj?.id,
    //                     subMethod: currentMethod,
    //                 });
    //                 return;
    //             }
    //         }
    //         //#endregion check data in dataTable

    //         controlsStatusSet({ processType: 3, subMethod: currentMethod, });

    //         //#region contract (add)
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         dataObj = {
    //             contract: contract,
    //             method: backend?.methods?.contractAdd,
    //             languageId: languageObj?.id,
    //             url: `${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}${backend?.urlProfile}`
    //         }

    //         result = await axios?.post(
    //             dataObj?.url,
    //             dataObj,
    //             headerObj,
    //         );

    //         response = result?.data || {};

    //         if (!response?.isSuccess || response?.isWarning) {
    //             controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //             await sendMessageCloseCurrentWindowAsync({
    //                 msgType: response?.msgType,
    //                 msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //                 closeWindow: false,
    //                 urlGoTo: response?.urlGoTo,
    //                 auth: auth,
    //                 isLogout: false,
    //                 languageId: languageObj?.id,
    //                 subMethod: currentMethod,
    //             });
    //             return;
    //         }

    //         buildingLocal = response.result?.building;
    //         contractLocal = response.result?.contract;
    //         //#endregion contract (add)

    //         //#region contract data default set
    //         response = contractDataDefaultSet({
    //             subMethod: currentMethod,
    //         });

    //         if (!response?.isSuccess || response?.isWarning) {
    //             controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //             await sendMessageCloseCurrentWindowAsync({
    //                 msgType: response?.msgType,
    //                 msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //                 closeWindow: false,
    //                 urlGoTo: response?.urlGoTo,
    //                 auth: auth,
    //                 isLogout: false,
    //                 languageId: languageObj?.id,
    //                 subMethod: currentMethod,
    //             });
    //             return;
    //         }
    //         //#endregion contract data default set

    //         //#region add row in dataTable
    //         dtRow = [contractLocal?.id, buildingLocal?.description];
    //         $(`#${dtContractsId}`)?.DataTable()?.row?.add(dtRow)?.draw();
    //         //#endregion add row in dataTable

    //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //         sendMessageCloseCurrentWindowAsync({
    //             msgType: 0,
    //             msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     } catch (ex) {
    //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     }
    // }
    //#endregion old code

    //#region old code
    // const userContractErrorsDefaultSet = ({
    //     subMethod = '',
    // }) => {
    //     const currentMethod = 'userContractErrorsDefaultSet';
    //     let response = responseGet();
    //     try {
    //         setErrorContractId('');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         console?.error(response);
    //     }
    //     return response;
    // }
    //#endregion old code

    //#region old code
    // const userContractDataValidate = async () => {
    //     let response = responseGet();
    //     try {
    //         if (isUndefined(contract.contractId) || isNull(contract.contractId) || isEmpty(contract.contractId)) {
    //             setErrorContractId(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
    //             response.isWarning = true;
    //         } else if (contract.contractId.length !== contractSet?.length) {
    //             setErrorContractId(`${messages?.allowedCharacters?.[languageObj?.id]}: <b>${contractSet?.length}</b>`);
    //             response.isWarning = true;
    //         }

    //         if (isUndefined(contract.userId) || isNull(contract.userId) || isEmpty(contract.userId)) {
    //             //setErrorContractId(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
    //             response.isWarning = true;
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localContractDataValidate<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth);
    //     }
    //     return response;
    // }
    //#endregion old code

    const contractDataDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'contractDataDefaultSet';
        let response = responseGet();
        try {
            //#region old code
            // setContract({
            //     contractId: '',
            //     userId: !isUndNullEmp({ data: auth?.user?.uid, subMethod: currentMethod, })?.result ?
            //         auth?.user?.uid :
            //         '',
            // });
            //#endregion old code
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion contracts (methods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ user: true, profile: true, });

            //#region variables
            let resultLocal = {
                user: userModelGet({}),
                apartments: [apartmentModelGet({})],
                buildings: [buildingModelGet({})],
                contracts: [buildingContractModelGet],
            };
            let dtRows = [];
            let contractsLocal = [];
            let userFilePhotoAcceptLocal = '';
            let loginLastDateTimeLocal = new Date()?.toISOString();
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            setBuildings([]);
            setApartments([]);
            //#endregion initialize

            //#region set dataTable /queryCode
            response = dataTablesSet({
                dtContracts: true,
                queryCodeSet_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ user: false, profile: false });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion set dataTable /queryCode

            //#region check status loged
            if (!auth?.isLoged()) {
                setShowLoading({ user: false, profile: false });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustLogInAccessThisSection?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: backend?.urlHome,
                    auth: auth,
                    isLogout: true,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion check status loged

            //#region profile data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                id: auth?.user?.uid,
                method: backend?.methods?.accounts?.profileGet,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}${backend?.urlProfile}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ user: false, profile: false });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            resultLocal = response.result;
            // if (isUndefined(resultLocal) || isNull(resultLocal) || isEmpty(resultLocal)) {
            //     setShowLoading({ user: false, profile: false });
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, backend?.urlHome, auth, true);
            //     return response;
            // }

            setUser(resultLocal?.user || {});
            setApartments(resultLocal?.apartments || []);
            setBuildings(resultLocal?.buildings || []);
            contractsLocal = resultLocal?.contracts || [];

            //#region set date time (last loggin)
            if (!isUndNullEmp({ data: auth?.user?.lastLoginAt, subMethod: currentMethod, })?.result) {
                loginLastDateTimeLocal = new Date(parseInt(auth?.user?.lastLoginAt));
            } else if (!isUndNullEmp({ data: auth?.user?.metadata?.lastSignInTime, subMethod: currentMethod, })?.result) {
                loginLastDateTimeLocal = new Date(auth?.user?.metadata.lastSignInTime);
            }

            setUserLastLogginDate(
                dateTimeFormatGlobalSet({
                    date: loginLastDateTimeLocal,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result
            );
            setUserLastLogginTime(
                dateTimeFormatGlobalSet({
                    date: loginLastDateTimeLocal,
                    type: '',
                    format: languageObj?.format?.time?.type,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set date time (last loggin)

            fileTypes?.forEach((detail, index) => {
                if ((index + 1) < fileTypes.length) {
                    userFilePhotoAcceptLocal += `${detail}, `;
                } else {
                    userFilePhotoAcceptLocal += `${detail}`;
                }
            });

            setUserPhotoAccept(userFilePhotoAcceptLocal);
            //#endregion profitle data get

            //#region contract data default set
            response = contractDataDefaultSet({
                subMethod: 'dataGetAsync',
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ user: false, profile: false });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion contract data default set

            //#region data in dataTable set
            if (!isUndNullEmp({ data: contractsLocal, subMethod: currentMethod, })?.result && contractsLocal?.length >= 1) {
                dtRows = contractsLocal?.map((detail) => {
                    return ([
                        detail?.contractId,
                        detail?.building?.description
                    ]);
                });

                $(`#${dtContractsId}`)?.DataTable()?.rows?.add(dtRows)?.draw();
            }
            //#endregion data in dataTable set

            setShowLoading({ user: false, profile: false });
        } catch (ex) {
            setShowLoading({ user: false, profile: false });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    };

    const validateFormData = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormData';
        let response = responseGet();
        try {
            //#region errorsDefaultSet
            setErrorLastName('');
            setErrorFirstName('');
            setErrorPhoneNumber('');
            //#endregion errorsDefaultSet

            //#region methods
            if (isUndNullEmp({ data: user?.firstName, subMethod: currentMethod, })?.result) {
                setErrorFirstName(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.lastName, subMethod: currentMethod, })?.result) {
                setErrorLastName(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.phoneNumber, subMethod: currentMethod, })?.result) {
                setErrorPhoneNumber(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!validatePhoneNumber({ phoneNumber: user?.phoneNumber })) {
                setErrorPhoneNumber(messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    //#region old code
    // const queryCodeSet = () => {
    //     let response = responseGet();
    //     try {
    //         //#region variables

    //         let localRowIndex = 0;
    //         let localDtRowIndex = 0;
    //         let localAttribute = {};
    //         let localMethodValue = '';
    //         let localId = '';
    //         let localDescription = '';

    //         //#endregion variables

    //         $(`#${dtContractsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
    //             e.preventDefault();
    //             localRowIndex = $(`#${dtContractsId}`)?.DataTable()?.row(this)?.index();
    //             localDtRowIndex = (!isUndefined(localRowIndex) ? localRowIndex : localDtRowIndex);
    //             if (!isUndefined(localDtRowIndex)) {
    //                 localAttribute = e?.target?.attributes.method;
    //                 localMethodValue = localAttribute === undefined ? '' : localAttribute.value;
    //                 localId = isUndefined(e?.target?.attributes.id) ? '' : e?.target?.attributes.id.value;
    //                 localDescription = isUndefined(e?.target?.attributes.description) ? '' : e?.target?.attributes.description.value;
    //                 switch (localMethodValue) {
    //                     case 'edit':
    //                         localBuildingEditDetailGetAsync(localId, localDescription, localDtRowIndex, 1);
    //                         break;
    //                     case 'details':
    //                         localBuildingEditDetailGetAsync(localId, localDescription, localDtRowIndex, 2);
    //                         break;
    //                     case 'delete':
    //                         localShowModalBuildingDeleteGetAsync(localId, localDescription, localDtRowIndex);
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //             }
    //         });
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: queryCodeSet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const dataTableContractsSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableContractsSet';
        let response = responseGet();
        try {
            $(`#${dtContractsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.code?.[languageObj?.id], width: '25%', },
                    { title: labels?.building?.[languageObj?.id], width: '75%', },
                    //{ title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                autoWidth: false,
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                lengthChange: true,
                order: [[1, 'asc']],
                responsive: true,
                //}).buttons().container().appendTo(`#${dtContractsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesSet = ({
        dtContracts = false,
        queryCodeSet_ = false,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'dataTablesSet';
        try {
            if (dtContracts) {
                response = dataTableContractsSet({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet_) {
                //#region old code
                // response = queryCodeSet();
                // if (!response?.isSuccess || response?.isWarning) {
                //     return response;
                // }
                //#endregion old code
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.profileSave?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.profileSave?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.passwordSave?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.passwordSave?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.contractAdd?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.contractAdd?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.profileFirstName?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.profileLastName?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.profilePhoneNumber?.id}`)?.attr({ disabled: processType !== 0, });
            //$(`#${controls?.selects?.countries?.id}`)?.attr({ disabled: processType !== 0, });

            $(`#${controls?.inputs?.passwordCurrent?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.passwordNew?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.passwordConfirm?.id}`)?.attr({ readOnly: processType !== 0, });

            $(`#${controls?.inputs?.contractCode?.id}`)?.attr({ readOnly: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.contracts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.contracts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            setTabsDisable(processType !== 0);

            if (processType !== 0) {
                $(`#${controls?.buttons?.profileSave?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.passwordSave.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.contractAdd?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth?.user?.uid]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.profile?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.profile?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>
                                {/* {!showLoading ? */}
                                {/* <div> */}
                                {/* {showData ? */}
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='card card-primary card-outline shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                                showText={true}
                                                text={messages?.processing?.[languageObj?.id]}
                                                height={25}
                                                hidden={!showLoading?.user}
                                                width={25}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-body box-profile'>
                                                <div className='text-center'
                                                    id={controls?.pictures?.user?.id}>
                                                    <a href={`#${controls?.pictures?.user?.id}`}>
                                                        <img className={controls?.pictures?.user?.className}
                                                            style={styles.profileUserPicture}
                                                            src={user?.photoURL || images?.noImageLogo}
                                                            alt={controls?.pictures?.user?.id}
                                                            onClick={(e) => userImageProfileChangeGet({ e: e, subMethod: 'img - userPhoto', })}
                                                        />
                                                    </a>
                                                </div>
                                                <a href={`#${controls?.pictures?.user?.id}`}>
                                                    <p style={{ fontSize: 10, }}
                                                        className='text-primary text-center'
                                                        onClick={(e) => userImageProfileChangeGet({ e: e, subMethod: 'paragraph', })}>
                                                        [{labels?.clickToChangePicture?.[languageObj?.id]}]
                                                    </p>
                                                </a>
                                                <h3 className='profile-username text-center'>{`${user?.firstName || ''}, ${user?.lastName || ''}`}</h3>
                                                <p className='text-muted text-center'><i className={icons?.userTag} /> {user?.role || ''}</p>
                                                <ul className='list-group list-group-unbordered mb-3'>
                                                    <li className='list-group-item text-muted'>
                                                        <i className={icons?.building} /> <b>{labels?.buildings?.[languageObj?.id]}</b> <NavLink className='float-right' to={backend?.urlBuildings}>{buildings?.length || 0}</NavLink>
                                                    </li>
                                                    <li className='list-group-item text-muted'>
                                                        <i className={icons?.houseUser} /> <b>{labels?.apartments?.[languageObj?.id]}</b> <NavLink className='float-right' to={backend?.urlApartments}>{apartments?.length || 0}</NavLink>
                                                    </li>
                                                    {/* <li className='list-group-item'><i className='far fa-chart-bar' /> <b>{labels?.rates}</b> <NavLink className='float-right' to='/rates'>{showData ? 0 : 0}</NavLink></li> */}
                                                    <li className='list-group-item text-muted'>
                                                        <i className={icons?.calendarAlt} /> {labels?.lastLogin?.[languageObj?.id]}
                                                        <label className='float-right text-muted'>
                                                            {userLastLogginDate || ''}<br />
                                                            {userLastLogginTime || ''}
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>

                                            {/* <div className='form-group' >
                                                <div className='input-group'>
                                                    <div className='custom-file'>
                                                        <input style={{ visibility: 'hidden', }}
                                                            accept={userPhotoAccept}
                                                            type='file'
                                                            className='custom-file-input'
                                                            id={controls?.inputs?.userPhoto?.id}
                                                            onChange={(e) => userImageProfileChangePostAsync(e)}>
                                                        </input>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className='card-footer'>
                                                {/* <button className='btn btn-outline-primary btn-block' /> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-8'>
                                        <div className='card card-primary card-outline shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                                showText={true}
                                                text={messages?.processing?.[languageObj?.id]}
                                                height={25}
                                                hidden={!showLoading?.profile}
                                                width={25}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header p-2'>
                                                <ul className='nav nav-pills'>
                                                    <li className='nav-item'
                                                        tooltip='tooltip'
                                                        data-toggle='tooltip'
                                                        title={labels?.profile?.[languageObj?.id]}>
                                                        <a className='nav-link active'
                                                            //href='#userData'
                                                            href={tabsDisable ? '#profile' : `#${userDataTabId}`}
                                                            data-toggle={tabsDisable ? '' : 'tab'}>
                                                            <i className={icons?.userEdit} />
                                                        </a>
                                                    </li>
                                                    <li className='nav-item'
                                                        tooltip='tooltip'
                                                        data-toggle='tooltip'
                                                        title={labels?.changePassword?.[languageObj?.id]}>
                                                        <a className='nav-link'
                                                            //href='#userSecurity'
                                                            href={tabsDisable ? '#profile' : `#${userSecurityTabId}`}
                                                            data-toggle={tabsDisable ? '' : 'tab'}>
                                                            <i className={icons?.key} />
                                                        </a>
                                                    </li>
                                                    <li className='nav-item'
                                                        tooltip='tooltip'
                                                        data-toggle='tooltip'
                                                        title={labels?.contracts?.[languageObj?.id]}>
                                                        <a className='nav-link'
                                                            //href='#userContracts'
                                                            href={tabsDisable ? '#profile' : `#${userContractsTabId}`}
                                                            data-toggle={tabsDisable ? '' : 'tab'}>
                                                            <i className={icons?.fileInvoice} />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className='card-body'>
                                                <div className='tab-content'>

                                                    <div className='active tab-pane'
                                                        id={userDataTabId}>
                                                        <form className='form-horizontal'
                                                            method='post'
                                                            onSubmit={(e) => userProfileEditPostAsync({ e: e, subMethod: 'form - onSubmit' })}>
                                                            {/* <div className='card card-info card-outline shadow-lg'> */}
                                                            {/* <div className=''> */}

                                                            <div className='form-group'>
                                                                <h5>{labels?.profile?.[languageObj?.id]}</h5>
                                                            </div>
                                                            {/* <div className='card-header'>
                                                                    <h5 className='card-title'>{labels?.profile?.[languageObj?.id]}</h5>
                                                                    <div className='card-tools'>
                                                                        <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.minus} /></button>
                                                                    </div>
                                                                </div> */}

                                                            {/* <div className='card-body'> */}
                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.profileFirstName?.id}
                                                                        className={controls?.inputs?.profileFirstName?.className}
                                                                        onChange={(e) => setUser({
                                                                            ...user,
                                                                            [dbProps?.firstName]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrorFirstName('')}
                                                                        placeholder={labels?.firstName?.[languageObj?.id]}
                                                                        title={labels?.firstName?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        //autoFocus
                                                                        value={user?.firstName || ''} />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'>
                                                                            <span className={icons?.user} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorFirstName)}</div>
                                                            </div>

                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.profileLastName?.id}
                                                                        className={controls?.inputs?.profileLastName?.className}
                                                                        onChange={(e) => setUser({
                                                                            ...user,
                                                                            [dbProps?.lastName]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrorLastName('')}
                                                                        placeholder={labels?.lastName?.[languageObj?.id]}
                                                                        title={labels?.lastName?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        value={user?.lastName || ''}
                                                                    />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'>
                                                                            <span className={icons?.user} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorLastName)}</div>
                                                            </div>

                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.profilePhoneNumber?.id}
                                                                        className={controls?.inputs?.profilePhoneNumber?.className}
                                                                        onChange={(e) => setUser({
                                                                            ...user,
                                                                            [dbProps?.phoneNumber]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrorPhoneNumber('')}
                                                                        placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                                                        title={labels?.phoneNumber?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        value={user?.phoneNumber || ''}
                                                                    />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'>
                                                                            <span className={icons?.mobileAlt} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorPhoneNumber)}</div>
                                                            </div>

                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.profileEmail?.id}
                                                                        className={controls?.inputs?.profileEmail?.className}
                                                                        onChange={(e) => setUser({
                                                                            ...user,
                                                                            [dbProps?.email]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrorEmail('')}
                                                                        placeholder={labels?.email?.[languageObj?.id]}
                                                                        readOnly
                                                                        title={labels?.email?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        value={user?.email || ''}
                                                                    />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'>
                                                                            <span className={icons?.envelope} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorEmail)}</div>
                                                            </div>

                                                            {/* <div className='form-group' >
                                                                <div className='input-group'>
                                                                    <div className='custom-file'>
                                                                        <input style={{ visibility: 'hidden', }}
                                                                            accept={userPhotoAccept}
                                                                            type='file'
                                                                            className='custom-file-input'
                                                                            id={controls?.inputs?.userPhoto?.id}
                                                                            onChange={(e) => userImageProfileChangePostAsync(e)}>
                                                                        </input>
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            {/* </div> */}

                                                            {/* <div className='card-footer text-right'>
                                                                    <div className='form-group'>
                                                                        <button type='submit'
                                                                            title={labels?.save?.[languageObj?.id]}
                                                                            className='btn btn-outline-primary float-right mx-1'>
                                                                            <i className={icons?.save} />
                                                                        </button>
                                                                    </div>
                                                                </div> */}

                                                            <div className='form-group text-right'>
                                                                <button id={controls?.buttons?.profileSave?.id}
                                                                    className={controls?.buttons?.profileSave?.className}
                                                                    type='submit'
                                                                    title={labels?.save?.[languageObj?.id]}>
                                                                    <i id={controls?.icons?.profileSave?.id} className={controls?.icons?.profileSave?.className} /> <span id={controls?.spinners?.profileSave?.id} className='' aria-hidden='true'></span>
                                                                </button>
                                                            </div>
                                                            {/* </div> */}
                                                        </form>
                                                    </div>

                                                    <div className='tab-pane'
                                                        id={userSecurityTabId} >
                                                        <form className='form-horizontal'
                                                            method='post'
                                                            onSubmit={(e) => userPasswordChangeAsync({ e: e, subtract: 'form - onSubmit', })}>
                                                            {/* <div className='card card-info card-outline shadow-lg'> */}

                                                            {/* <div className='card-header'>
                                                                    <h5 className='card-title'>{labels?.changePassword?.[languageObj?.id]}</h5>
                                                                    <div className='card-tools'>
                                                                        <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.minus} /></button>
                                                                    </div>
                                                                </div> */}

                                                            <div className='form-group'>
                                                                <h5 >{labels?.changePassword?.[languageObj?.id]}</h5>
                                                            </div>

                                                            {/* <div className='card-body'> */}
                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.passwordCurrent?.id}
                                                                        className={controls?.inputs?.passwordCurrent?.className}
                                                                        placeholder={labels?.currentPassword?.[languageObj?.id]}
                                                                        title={labels?.currentPassword?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        value={formDataChangePassword?.currentPassword || ''}
                                                                        onChange={(e) => setFormDataChangePassword({
                                                                            ...formDataChangePassword,
                                                                            [dbProps?.currentPassword]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrroCurrentPassword('')}
                                                                    />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'
                                                                            type='button'>
                                                                            <span className={showPassword ? icons?.eyeIpasswordIpassword : icons?.eyeSlashIpasswordIpassword}
                                                                                onClick={(e) => setShowPassword(!showPassword)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorCurrentPassword)}</div>
                                                            </div>

                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.passwordNew?.id}
                                                                        className={controls?.inputs?.passwordNew?.className}
                                                                        placeholder={labels?.newPassword?.[languageObj?.id]}
                                                                        title={labels?.newPassword?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        value={formDataChangePassword?.newPassword || ''}
                                                                        onChange={(e) => setFormDataChangePassword({
                                                                            ...formDataChangePassword,
                                                                            [dbProps?.newPassword]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrroNewPassword('')}
                                                                    />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'
                                                                            type='button'>
                                                                            <span className={showPassword ? icons?.eyeIpasswordIpassword : icons?.eyeSlashIpasswordIpassword}
                                                                                onClick={(e) => setShowPassword(!showPassword)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorNewPassword)}</div>
                                                            </div>

                                                            <div className='form-group'>
                                                                <div className='input-group mb-3'>
                                                                    <input id={controls?.inputs?.passwordConfirm?.id}
                                                                        className={controls?.inputs?.passwordConfirm?.className}
                                                                        placeholder={labels?.confirmNewPassword?.[languageObj?.id]}
                                                                        title={labels?.confirmNewPassword?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        value={formDataChangePassword?.confirmNewPassword || ''}
                                                                        onChange={(e) => setFormDataChangePassword({
                                                                            ...formDataChangePassword,
                                                                            [dbProps?.confirmNewPassword]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrorConfirmNewPassword('')}
                                                                    />
                                                                    <div className='input-group-append'>
                                                                        <div className='input-group-text'
                                                                            type='button'>
                                                                            <span className={showPassword ? icons?.eyeIpasswordIpassword : icons?.eyeSlashIpasswordIpassword}
                                                                                onClick={(e) => setShowPassword(!showPassword)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorConfirmNewPassword)}</div>
                                                            </div>
                                                            {/* </div> */}

                                                            {/* <div className='card-footer text-right'>
                                                                    <div className='form-group'>
                                                                        <button title={labels?.save?.[languageObj?.id]}
                                                                            className='btn btn-outline-primary float-right mx-1'>
                                                                            <i className={icons?.save} />
                                                                        </button>
                                                                    </div>
                                                                </div> */}

                                                            <div className='form-group text-right'>
                                                                <button id={controls?.buttons?.passwordSave?.id}
                                                                    className={controls?.buttons?.passwordSave?.className}
                                                                    title={labels?.save?.[languageObj?.id]}
                                                                    type='submit'>
                                                                    <i id={controls?.icons?.passwordSave?.id} className={controls?.icons?.passwordSave?.className} /> <span id={controls?.spinners?.passwordSave?.id} className='' aria-hidden='true'></span>
                                                                </button>
                                                            </div>
                                                            {/* </div> */}
                                                        </form>
                                                    </div>

                                                    <div className='tab-pane'
                                                        id={userContractsTabId} >
                                                        {/* <div className='card card-info card-outline shadow-lg'> */}
                                                        {/* <div className='card-header'>
                                                                <h5 className='card-title'>{labels?.contracts?.[languageObj?.id]}</h5>
                                                                <div className='card-tools'>
                                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'><i className={icons?.minus} /></button>
                                                                </div>
                                                            </div> */}

                                                        {/* <div className='card-body'> */}
                                                        {/* <form className='form-horizontal'
                                                            method='post'
                                                            onSubmit={(e) => userContractAddAsync({ e: e, subMethod: 'form - onSubmit', })}>
                                                            <div className='row'>
                                                                <div className='form-group'>
                                                                    <h5>{labels?.contracts?.[languageObj?.id]}</h5>
                                                                </div>
                                                            </div>

                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <input id={controls?.inputs?.contractCode?.id}
                                                                        className={controls?.inputs?.contractCode?.className}
                                                                        maxLength={contractSet?.length}
                                                                        minLength={contractSet?.length}
                                                                        onChange={(e) => setContract({
                                                                            ...contract,
                                                                            [dbProps?.contractId]: e?.target?.value,
                                                                        })}
                                                                        onFocus={() => setErrorContractId('')}
                                                                        placeholder={labels?.contract?.[languageObj?.id]}
                                                                        title={labels?.contract?.[languageObj?.id]}
                                                                        tooltip='tooltip'
                                                                        type={new Text()}
                                                                        value={contract?.contractId || ''} />
                                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorContractId)}</div>
                                                                </div>
                                                                <div className='col-md-3'>
                                                                    <button id={controls?.buttons?.contractAdd?.id}
                                                                        className={controls?.buttons?.contractAdd?.className}
                                                                        title={labels?.save?.[languageObj?.id]}
                                                                        type='submit'>
                                                                        <i id={controls?.icons?.contractAdd?.id}
                                                                            className={controls?.icons?.contractAdd?.className} /> <span id={controls?.spinners?.contractAdd?.id} className='' aria-hidden='true'></span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form> */}
                                                        {/* <br /> */}
                                                        <hr />
                                                        <div className='row'>
                                                            <div className={html?.dataTables?.formats?.tableResponsiveSm}>
                                                                <table id={dtContractsId} className={html?.dataTables?.formats?.smStripedBordered}></table>
                                                            </div>
                                                        </div>
                                                        {/* </div> */}

                                                        {/* <div className='card-footer text-right'></div> */}

                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='form-group' >
                                        <div className='input-group'>
                                            <div className='custom-file'>
                                                <input style={{ visibility: 'hidden', }}
                                                    accept={userPhotoAccept}
                                                    type='file'
                                                    className={controls?.inputs?.profileUserPhoto?.className}
                                                    id={controls?.inputs?.profileUserPhoto?.id}
                                                    onChange={(e) => userImageProfileChangePostAsync({ e: e, subMethod: 'input - profileUserPhoto', })}>
                                                </input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* :  */}
                                {/* <></> */}
                                {/* } */}
                                {/* </div> */}
                                {/* : */}
                                {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                        width={40}
                                        height={40}
                                        color={colors?.infoColorExp}
                                        msgText={messages?.processing?.[languageObj?.id]}
                                        msgOrientation='text-center'
                                        msgTextMuted={true} /> */}
                                {/* } */}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

        </div>
    )
}